import { type FC } from "react";
import { Checkbox } from "@root/shared/components/Checkbox";
import * as styles from "./styles.css";

type Props = {
  isMultiScoutChecked: boolean;
  updateAllUser: () => void;
  isDisabled: boolean;
};

export const MultiScoutCheckbox: FC<Props> = ({
  isMultiScoutChecked,
  updateAllUser,
  isDisabled,
}) => (
  <p className={styles.multiCheckboxOuter}>
    <Checkbox checked={isMultiScoutChecked} onChange={updateAllUser} disabled={isDisabled} />
    一括スカウト
  </p>
);
